if (!customElements.get('pdp-rating-widget')) {
    customElements.define('pdp-rating-widget', class PdpRatingWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.dataset.rendered === 'true') return;

        const apiToken = this.getAttribute("data-api-t");

        if (!apiToken) return;

        const productId = this.dataset.productId;
        if (!productId) return;

        this.fetchRatingData(productId, apiToken);
      }

      async fetchRatingData(productId, apiToken) {
        try {
          const response = await fetch(`https://pub.kudosi.ai/public/products/rating?product_ids=${productId}`, {
            headers: {
              "Authorization": `Bearer ${apiToken}`
            }
          });

          if (!response.ok) {
            this.style.display = "none";
            return;
          }

          const data = await response.json();

          if (!data.data || !Object.keys(data.data).length) {
            this.style.display = "none";
            return;
          }

          let productData = data.data[productId];

          if (!productData) {
            this.style.display = "none";
            return;
          }

          const ratingVal = parseFloat(productData.average_rating);
          const reviewCount = parseInt(productData.total);

          if (reviewCount > 0 && ratingVal > 0) {
            this.renderWidget(ratingVal, reviewCount);
          } else {
            this.style.display = "none";
          }
        } catch (err) {
          console.error('PdpRatingWidget API Error:', err);
          this.style.display = "none";
        }
      }

      getVerbalRating(rating) {
        if (rating >= 4.3) return 'Excellent';
        if (rating >= 3.8) return 'Great';
        if (rating >= 3.3) return 'Average';
        if (rating >= 2.8) return 'Poor';
        return 'Bad';
      }

      formatRatingNumber(rating) {
        const rounded = rating.toFixed(1);
        return rounded;
      }

      renderWidget(ratingVal, reviewCount) {
        const ratingText = this.getVerbalRating(ratingVal);
        const formattedRating = this.formatRatingNumber(ratingVal);

        let starsHtml = '';
        for (let i = 1; i <= 5; i++) {
          const diff = ratingVal - i + 1;
          let fillPercent = 0;
          if (diff >= 0.75) {
            fillPercent = 100;
          } else if (diff >= 0.25) {
            fillPercent = 50;
          }

          starsHtml += `
            <div class="pdp-rating__star-box" style="background: linear-gradient(90deg, #00b67a ${fillPercent}%, #e1e1e1 ${fillPercent}%);">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="#ffffff" aria-hidden="true">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            </div>
          `;
        }

        this.innerHTML = `
          <span class="pdp-rating__label">${ratingText}</span>
          <div class="pdp-rating__stars" aria-label="Rating ${formattedRating} out of 5">
            ${starsHtml}
          </div>
          <span class="pdp-rating__meta">
            ${formattedRating} &middot; ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}
          </span>
        `;

        this.dataset.rendered = 'true';
        this.classList.remove('is-loading');
      }
    });
}